import script from "./modal1.vue?vue&type=script&setup=true&lang=js"
export * from "./modal1.vue?vue&type=script&setup=true&lang=js"

import "./modal1.vue?vue&type=style&index=0&id=f8b58ed6&lang=scss"

const __exports__ = script;

export default __exports__